import {
  Box,
  Center,
  Grid,
  HStack,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack
} from '@chakra-ui/react';
import React, { FC } from 'react';

import s from '@app/components/Swap/components/TokenSelector/TokenSelector.module.scss';
import { useRouterIntentState } from '@app/state/routerIntentStore';
import {
  Arbitrum,
  Ethereum,
  Polygon,
  Linea,
  Mantle,
  MantaPacific
} from '@thirdweb-dev/chains';

interface Props {
  onClose: () => void;
  isOpen: boolean;
}

const NETWORKS = [Arbitrum, Ethereum, Polygon, Linea, Mantle, MantaPacific];

export const SelectNetworkModal: FC<Props> = ({ onClose, isOpen }) => {
  const {
    actions: { setSourceNetwork, setSourceToken, setSourceAmount }
  } = useRouterIntentState();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      isCentered
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent sx={{ maxWidth: ['100vw', '600px'] }}>
        <ModalHeader>
          <HStack justify="space-between" px={0} py={0} mb="16px">
            <Text fontSize="16px" color="white" fontWeight="500">
              Select token
            </Text>
            <ModalCloseButton
              onClick={() => {
                onClose();
              }}
            />
          </HStack>
        </ModalHeader>

        <VStack>
          <Box
            className={s.scrollWrapper}
            overflowY="auto"
            height={400}
            mt={4}
            w="100%"
          >
            {NETWORKS?.map(item => {
              return (
                <Grid
                  onClick={() => {
                    setSourceNetwork(item);
                    setSourceToken(null);
                    setSourceAmount('');
                    onClose();
                  }}
                  style={{
                    cursor: 'pointer',
                    transition: 'background 0.2s ease-out'
                  }}
                  key={item.chainId}
                  gridTemplateColumns="48px 1fr 100px"
                  gridColumnGap="8px"
                  gridRowGap={0}
                  borderBottom="1px solid"
                  borderColor="whiteOpacity.6"
                  alignItems="center"
                  _hover={{ background: 'neutral.700' }}
                  w="100%"
                  gridTemplateAreas="'icon source details' 'icon symbol details'"
                  py="12px"
                  px="12px"
                >
                  <Center
                    sx={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      overflow: 'hidden',
                      background: 'neutral.700'
                    }}
                  >
                    <img
                      src={item?.icon?.url.replace(
                        'ipfs://',
                        'https://ipfs.io/ipfs/'
                      )}
                      style={{ width: '24px', height: '24px' }}
                      alt="Network logo"
                    />
                  </Center>

                  <Text
                    fontSize="16px"
                    lineHeight="21px"
                    fontWeight={500}
                    color="neutral.100"
                    gridArea="source"
                    textAlign="left"
                  >
                    {item.name}
                  </Text>
                </Grid>
              );
            })}
          </Box>
        </VStack>
      </ModalContent>
    </Modal>
  );
};
